import { render, staticRenderFns } from "./IconTagOutline.vue?vue&type=template&id=0b90f5f8"
import script from "./IconTagOutline.vue?vue&type=script&lang=js"
export * from "./IconTagOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports